import {FormItemDataModel} from './form-item-data.model';
import {FormParagraphConfigurationModel} from '../form-paragraph-configuration.model';
import {XauditModel} from '../../xaudit.model';

export class FormParagraphDataModel extends XauditModel {
    dataFormParagraphID: string;
    CaseWorkItemFormsId: string;
    DFormParagraphId: string;
    ParagraphOrder: number;
    DocumentGroupID: string;
    cfgDFormParagraph: FormParagraphConfigurationModel;
    dataFormItems: FormItemDataModel[];
}
